module.exports = __webpack_public_path__ + "static/media/play_intro.e5463db9.png";